import dayjs from 'dayjs';
import { useEffect, useMemo, useState } from 'react';

interface TimerProps {
  reverse?: {
    initalTime: number;
  };
}

// FIXME: 인터페이스 설계 변경
const useTimer = (props: TimerProps = {}) => {
  const { reverse } = props;
  const [startTime, setStartTime] = useState(dayjs());
  const [time, setTime] = useState(reverse ? reverse.initalTime : 0);

  useEffect(() => {
    const timerId = setInterval(() => {
      const diff = reverse
        ? reverse.initalTime - dayjs().diff(startTime, 'second')
        : dayjs().diff(startTime, 'second');

      setTime(diff);
    }, 1000);
    return () => {
      clearTimeout(timerId);
    };
  }, [startTime, setTime, reverse]);

  const formatedTime = useMemo(() => {
    if (time < 0) {
      return '00:00';
    }

    const minute = Math.floor(time / 60);
    const second = time % 60;

    const formatedMinute = minute < 10 ? `0${minute}` : `${minute}`;
    const formatedSecond = second < 10 ? `0${second}` : `${second}`;
    return `${formatedMinute}:${formatedSecond}`;
  }, [time]);

  const reset = () => {
    setStartTime(dayjs());
  };

  return {
    time,
    reset,
    formattedTime: formatedTime
  };
};

export default useTimer;
